import { render, staticRenderFns } from "./loc-type-cards.vue?vue&type=template&id=10208384&"
import script from "./loc-type-cards.vue?vue&type=script&lang=js&"
export * from "./loc-type-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports